import { getAppcuesAccountId } from '../config';
import { createDeferredLoader, loadScript } from './deferredLoader';
import type { AnalyticsProvider } from './types';

const APPCUES_PROVIDER_NAME = 'Appcues';
const APPCUES_SCRIPT_ID = 'appcues-flows';

const loader = createDeferredLoader({ name: APPCUES_PROVIDER_NAME });

const withClient = (action: (client: AppcuesClient) => void) =>
  loader.enqueue(() => {
    const client = window.Appcues;
    if (client) {
      action(client);
    }
  });

export const appcuesProvider: AnalyticsProvider = {
  name: APPCUES_PROVIDER_NAME,

  load: () => {
    const accountId = getAppcuesAccountId();
    if (!accountId) {
      return;
    }

    loader.start(() => loadScript({ id: APPCUES_SCRIPT_ID, src: `https://fast.appcues.com/${accountId}.js` }));
  },

  identify: ({ userId, traits }) => withClient((client) => client.identify(userId, traits)),

  group: ({ groupId, traits }) => withClient((client) => client.group(groupId, traits)),

  /** Appcues re-evaluates which flows qualify on every page call, so this drives flow delivery rather than reporting. */
  page: () => withClient((client) => client.page()),

  track: ({ name, properties }) => withClient((client) => client.track(name, properties)),

  reset: () => withClient((client) => client.reset()),
};
